import { render, staticRenderFns } from "./email-tabs.vue?vue&type=template&id=7a2571b6"
import script from "./email-tabs.vue?vue&type=script&lang=js"
export * from "./email-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports